import { FC, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { SciPage } from 'src/components/shared/SciPage';
import {
    setCarouselDotsCurrentPage,
    setCarouselPageIsCompletedAction,
} from 'src/components/shared/SciPage/SciPage.duck';
import { SciPagesEnum } from 'src/components/shared/SciPage/types';
import { SciContent } from 'src/components/shared/SciContent';
import { sciContentKeys } from 'src/constants';

import { MODULE_PREFIX } from './arrivalTime.constant';
import msg from './arrivalTime.messages';
import * as S from './arrivalTime.style';
import { ArrivalTimeForm } from './arrivalTime.form';

export const componentArrivalTime = `${MODULE_PREFIX}-component`;

export const ArrivalTimeComponent: FC = () => {
    const dispatch = useDispatch();
    const intl = useIntl();

    useEffect(() => {
        dispatch(setCarouselDotsCurrentPage(SciPagesEnum.ArrivalTime));
    }, [dispatch]);

    return (
        <SciPage>
            <S.Container data-test-id={componentArrivalTime}>
                <S.Header>
                    <S.Title>{intl.formatMessage(msg.pageItems.title)}</S.Title>
                    <S.StyleContainedModal
                        dialogInfo={
                            <SciContent
                                sciContentKey={
                                    sciContentKeys.sciInfoBoxArrivalTime
                                }
                            />
                        }
                    />
                </S.Header>
                <S.PageDescriptionContainer>
                    <SciContent
                        sciContentKey={
                            sciContentKeys.sciArrivalTimePageDescription
                        }
                    />
                </S.PageDescriptionContainer>
            </S.Container>
            <ArrivalTimeForm
                successCallback={() => {
                    dispatch(
                        setCarouselPageIsCompletedAction({
                            page: SciPagesEnum.ArrivalTime,
                        }),
                    );
                }}
            />
        </SciPage>
    );
};
